import { render, staticRenderFns } from "./QuotationTaskEdit.vue?vue&type=template&id=714b72c0"
import script from "./QuotationTaskEdit.vue?vue&type=script&lang=js"
export * from "./QuotationTaskEdit.vue?vue&type=script&lang=js"
import style0 from "./QuotationTaskEdit.vue?vue&type=style&index=0&id=714b72c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports